import React, { useState, useEffect } from 'react';
import ClickAwayListener from '@mui/base/ClickAwayListener';
import { UserIcon } from '@thrivetribe/mvf.assets.icons.user-icon';
import { Accordion } from '@thrivetribe/mvf.ui.atoms.accordion';
import { Arrow } from '@thrivetribe/mvf.assets.icons.arrow';
import classNames from 'classnames';

interface Link {
  url: string;
  text: string;
}

interface HeaderProfileNavProps {
  links?: Link[];
  user?: string;
}

export const HeaderProfileNav: React.FC<HeaderProfileNavProps> = ({
  links,
  user,
}: HeaderProfileNavProps) => {
  const [isProfileNavOpen, setIsProfileNavOpen] = useState<boolean>(false);

  return (
    <ClickAwayListener
      onClickAway={() => {
        setIsProfileNavOpen(false);
      }}
    >
      <div
        className={classNames('header__profile-nav', {
          'header__profile-nav--no-link': !links,
        })}
        tabIndex={0}
        onClick={() => setIsProfileNavOpen(!isProfileNavOpen)}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            setIsProfileNavOpen(!isProfileNavOpen);
          }
        }}
      >
        <div className='header__profile-nav__container'>
          <UserIcon />
          <span className='header__users-name'>{user}</span>
          {links && links.length > 0 && (
            <span
              className={`header__profile-nav-arrow${
                isProfileNavOpen ? '--open' : ''
              }`}
            >
              <Arrow />
            </span>
          )}
        </div>
        <div className={`header__profile-nav__links`}>
          <Accordion
            isAccordionOpen={isProfileNavOpen}
            id='profile-nav__accordion'
          >
            {links?.map((link, index) => (
              <a
                key={index}
                href={link.url}
                tabIndex={isProfileNavOpen ? 0 : -1}
              >
                {link.text}
              </a>
            ))}
          </Accordion>
        </div>
      </div>
    </ClickAwayListener>
  );
};
